import types from 'store/types/routing';
import Requester from '../../helpers/requester';
import { HTTP_METHODS } from 'helpers/constants';
import { API_PATHS } from 'helpers/endpoints';

export default {
  setLoading: (loading) => async (dispatch) => {
    return dispatch({ type: types.ROUTING_SET, key: 'loading', data: loading });
  },
  setReloadOrders: (orders) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'reloadOrders',
      data: orders,
    });
  },

  setSelectedOrders: (selectedOrders) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'selectedOrders',
      data: selectedOrders,
    });
  },

  setSelectedCouriers: (selectedCouriers) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'selectedCouriers',
      data: selectedCouriers,
    });
  },
  setConfirmDisabled: (confirm) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'setConfirmDisabled',
      data: confirm,
    });
  },

  setSelectSlots: (selectedSlots) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'selectedSlots',
      data: selectedSlots,
    });
  },
  setSlotsParentType: (parentType) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'slotsParentType',
      data: parentType,
    });
  },
  setSelectedSubZones: (subZones) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'selectedSubZones',
      data: subZones,
    });
  },
  setZoneId: (id) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'selectedZoneId',
      data: id,
    });
  },

  setStateSelectedZoneId: (zoneId) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'selectedZoneId',
      data: zoneId,
    });
  },
  setRouteMonitoringTaskId: (id) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'routeMonitoringTaskId',
      data: id,
    });
  },

  setRouteMonitoringRouteTaskId: (taskId) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'routeMonitoringRouteTaskId',
      data: taskId,
    });
  },
  setAllCouriersInfo: (allCouriers) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'allCouriers',
      data: allCouriers,
    });
  },
  setOrdersLatLon: (id) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'ordersLatLon',
      data: id,
    });
  },

  updateRoutingValue: (key, value) => {
    return {
      type: types.ROUTING_SET,
      key,
      data: value,
    };
  },

  setIsReRoutingRequired: (data) => async (dispatch) => {
    return dispatch({
      type: types.ROUTING_SET,
      key: 'isReRoutingRequired',
      data: data,
    });
  },

  getSlotTemplates: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.SLOT_TEMPLATES_SEARCH}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteSlotTemplates: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.SLOT_TEMPLATES}/delete`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getZonesByStoreIdForRouting: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.GET,
      url: `${API_PATHS.ZONES}/store/${payload}`,
    });
  },

  getSlotsByZoneId: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.GET,
      url: `${API_PATHS.SLOTS}/by-zone/${payload}`,
    });
  },

  getCurrentSlotsByZoneId: (zoneId) => {
    return Requester.submit({
      method: HTTP_METHODS.GET,
      url: `${API_PATHS.SLOTS}/${zoneId}`,
    });
  },

  getOrdersBySlotIdForRouting: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.POST,
      url: `${API_PATHS.ORDERS}/for-routing-by-slot-id-list`,
      data: payload,
    });
  },

  routeOrdersWithCouriers: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.POST,
      url: `${API_PATHS.ROUTES}/orders`,
      data: payload,
    });
  },

  getCouriersByZoneIdForRouting: (id) => {
    return Requester.submit({
      method: HTTP_METHODS.GET,
      url: `${API_PATHS.COURIERS}/for-routing-by-zone-id/${id}`,
    });
  },

  getRouteTaskDetails: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.ROUTING_TASK}/detail/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  approveRouting: async (taskId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.APPROVE_ROUTES}/${taskId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  isRoutingComplete: async (taskId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.ROUTES}/is-routing-complete/${taskId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSlotsByDateRange: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.GET,
      url: `${API_PATHS.SLOTS}/data/${payload}`,
    });
  },

  getReasonTypes: async () => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.REASON_TYPES}/ROUTE`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRoutingViewList: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ROUTING_TASK}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRoutingViewListById: async (routeID) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ROUTING_TASK}/detail/${routeID}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  reRoutes: async (routeID) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.RE_ROUTES}/${routeID}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  isReRoutingReq: async (routeID) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.IS_RE_ROUTING_REQ}/${routeID}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  transferOrdersForCourier: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIER_ASSIGNMENT}/transfer-orders-for-courier`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  switchOrdersForCourier: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIER_ASSIGNMENT}/switch-orders-for-courier`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeRoutingViewListData: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ROUTING_TASK}/cancel`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
